// ---------------------------------------------------------------------------
// Audit Log - formatters for action/resource labels, styles, and dates
// ---------------------------------------------------------------------------

import {
  ACTION_LABELS,
  ACTION_STYLES,
  DEFAULT_ACTION_STYLE,
  RESOURCE_LABELS,
  type ActionStyle,
} from "./constants";

export function getActionStyle(action: string): ActionStyle {
  return ACTION_STYLES[action] ?? DEFAULT_ACTION_STYLE;
}

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function getResourceLabel(resource: string): string {
  return RESOURCE_LABELS[resource] ?? resource;
}

// ---------------------------------------------------------------------------
// Relative time + full date
// ---------------------------------------------------------------------------

export function relativeTime(dateString: string): string {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return "A l'instant";
  if (diffMin < 60) return `il y a ${diffMin} min`;
  if (diffHour < 24) return `il y a ${diffHour}h`;
  if (diffDay < 7) return `il y a ${diffDay}j`;
  return new Date(dateString).toLocaleDateString("fr-SN");
}

export function formatFullDate(d: string): string {
  return new Date(d).toLocaleString("fr-SN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
